import { css } from '@emotion/css';
import { m } from '@snapchat/snap-design-system-marketing';

export const loadingTrackCss = css`
  background: none;
  /* The first child of the conversation container has 'margin-top: auto;' to push messages to the bottom.
   * This can lead to this loading indicator element being collapsed by the flex algorithm, so we need
   * to prevent it from shrinking. 
   */
  flex-shrink: 0;
  height: ${m('--spacing-xxxs')};
  overflow: hidden;
  position: relative;
  width: 100%;
`;

export const loadingLineCss = css`
  animation: fillAndSlide 2s cubic-bezier(0.4, 0, 0.2, 1) infinite;
  background-color: ${m('--palette-plain-black')};
  height: 100%;
  left: 0;
  position: absolute;
  right: 100%;

  @keyframes fillAndSlide {
    0% {
      left: 0;
      right: 100%;
    }

    50% {
      left: 0;
      right: 0;
    }

    100% {
      left: 100%;
      right: 0;
    }
  }
`;
